import React, { Fragment } from 'react';
import inflection from 'inflection';

import IdeaSubmitButton from 'buyside/components/container/RankingsIndex/SubmitResearchButtonContainer';
import FilterExpanding from 'buyside/components/presentation/Filters/FilterExpanding/filterExpanding';
import { MobileSidebar } from '../IndexPage/IndexPage';
import RankIndex, {
  RankCards,
  TitleCard
} from 'buyside/components/presentation/RankingsIndexPage/rankIndex/RankIndex';
import RankingsSidebar from './RankingsSidebar';

import { newIdeaUrl } from 'buyside/util/urlHelper';

import styles from './RankingsIndexStyles';
import { BREAKPOINTS, useIsMobile } from 'buyside/util/hooks/useIsMobile';

const IdeaSubmitLink = ({ requiredSubmissionAmount, category }) => {
  return (
    <IdeaSubmitButton>
      {() => {
        return (
          <p>
            <a className={styles.link} href={`${newIdeaUrl()}`}>
              Submit at least {requiredSubmissionAmount ? requiredSubmissionAmount : ''}{' '}
              {inflection.titleize(category)} ideas
            </a>{' '}
            which carry a positive aggregate return to be included in ranking calculations for this
            section.
          </p>
        );
      }}
    </IdeaSubmitButton>
  );
};

const RankingsIndexArea = ({
  canViewIdeaFilterDetails,
  canViewUserDetails,
  category,
  fetchNextPage,
  hasNextPage,
  isPublic,
  rankingDate,
  ranks,
  requiredSubmissionAmount,
  showIdeasLink
}) => {
  const isMobile = useIsMobile(BREAKPOINTS.LARGE);

  return (
    <Fragment>
      {!isPublic && (
        <IdeaSubmitLink requiredSubmissionAmount={requiredSubmissionAmount} category={category} />
      )}
      <MobileSidebar>
        {({ mobileSidebarStyle }) => (
          <FilterExpanding
            title="All Categories"
            filterStyle={isMobile ? styles.showSidebar : styles.hideSidebar}
          >
            <div className={`${mobileSidebarStyle} ${styles.mobileSidebar}`}>
              <RankingsSidebar category={category} />
            </div>
          </FilterExpanding>
        )}
      </MobileSidebar>
      <RankIndex
        category={category}
        canViewIdeaFilterDetails={canViewIdeaFilterDetails}
        canViewUserDetails={canViewUserDetails}
        showIdeasLink={showIdeasLink}
        ranks={ranks}
        hasNextPage={hasNextPage}
        fetchNextPage={fetchNextPage}
        rankingCreatedDate={rankingDate}
        isBlank={!ranks}
        isPublic={isPublic}
      >
        <TitleCard />
        <RankCards />
      </RankIndex>
    </Fragment>
  );
};

export default RankingsIndexArea;
